import { ProductSortOptionInterface, ProductSortOptionsTitles } from '@client-monorepo/daily-fintech/stores';
import { OrderTypes } from '@client-monorepo/common/network';

export const ProductSortOptionsConst: ProductSortOptionInterface[] = [
  {
    title: ProductSortOptionsTitles.POPULAR,
    field: 'click',
    order: OrderTypes.DESC,
  },
  {
    title: ProductSortOptionsTitles.DISCOUNT,
    field: 'discountPercent',
    order: OrderTypes.DESC,
  },
  {
    title: ProductSortOptionsTitles.PRICE_ASC,
    field: 'price',
    order: OrderTypes.ASC,
  },
  {
    title: ProductSortOptionsTitles.PRICE_DESC,
    field: 'price',
    order: OrderTypes.DESC,
  },
];
